module.exports = __webpack_public_path__ + "static/media/18ECA7.edffb8e6.jpg";